import styled from "styled-components";
export const ManagementStyle = styled.div``;
